export default "__VITE_ASSET__DmoJg$HL__"